import SimpleAccordion from "qubCommon/Accordions/SimpleAccordion";
import "./LegalFiles.css";

const url = import.meta.env.VITE_REACT_APP_BASE_URL;

const containerStyle = {
    padding: '20px',
    fontFamily: 'Arial, sans-serif',
    color: '#222',
};

const titleStyle = {
    fontSize: '22px',
    fontWeight: '700',
    marginBottom: '16px',
};

const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    tableLayout: 'fixed',
};

const cellStyle = {
    border: '1px solid #666',
    padding: '12px 16px',
    verticalAlign: 'top',
    fontSize: '16px',
    lineHeight: '1.4',
};

const leftCellStyle = {
    ...cellStyle,
    width: '60%',
};

const rightCellStyle = {
    ...cellStyle,
    width: '40%',
    textAlign: 'right',
    fontWeight: '600',
    whiteSpace: 'nowrap',
};

const underlineBold = {
    fontWeight: '700',
    textDecoration: 'underline',
};

const LegalFiles2026 = () => {
    return (
        <>
            <SimpleAccordion
                title={
                    <span style={{ fontWeight: "bold", color: "#003476", fontSize: 18 }}>
                        Νομοθετικό Πλαίσιο
                    </span>
                }
                content={
                    <p>
                        Οι προϋποθέσεις και οι όροι χορήγησης της παροχής των Χρηματικών Βοηθημάτων – Βραβείων καθορίζονται στην{" "}
                        <a
                            className=" ds-link small-font-size "
                            href={"/lae-miteres/KYA-7515-2026-04-24.pdf"}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Υπουργική Απόφαση αριθ. 7515/2026 (ΦΕΚ 2636/Β/24-04-2026)
                        </a>
                        :
                        <br />
                        <strong>
                            «Καθορισμός Προγραμμάτων του Λογαριασμού Αγροτικής Εστίας του Οργανισμού Προνοιακών Επιδομάτων και Κοινωνικής Αλληλεγγύης (ΟΠΕΚΑ) – (ΛΑΕ/ΟΠΕΚΑ), έτους 2026»
                        </strong>
                        <br />
                        <br />
                        Αναλυτικά τους όρους του προγράμματος παροχής χρηματικών βοηθημάτων – βραβείων μπορείτε να διαβάσετε                         <a
                            className=" ds-link small-font-size "
                            href={`${url}/documents/2026 ΟΡΟΙ ΤΡΙΤΕΚΝΕΣ-ΠΟΛΥΤΕΚΝΕΣ_ΜΕ ΑΔΑ_28.5.26.pdf`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >εδώ.</a>
                    </p>
                }
            />
            <br />
            {/* <SimpleAccordion
                title={
                    <span style={{ fontWeight: "bold", color: "#003476", fontSize: 18 }}>
                        Πληροφορίες Δικαιούχων
                    </span>
                }
                content={
                    <p>
                        <a
                            className=" ds-link small-font-size "
                            href={
                                "https://opeka.gr/wp-content/uploads/2025/07/%CE%A0%CE%9B%CE%97%CE%A1%CE%9F%CE%A6%CE%9F%CE%A1%CE%99%CE%95%CE%A3-%CE%94%CE%99%CE%9A%CE%91%CE%99%CE%9F%CE%A5%CE%A7%CE%A9%CE%9D-%CE%A4%CE%A1%CE%99.-%CE%A0%CE%9F%CE%9B%CE%A5%CE%A4.-2025.-24-7-2025.pdf"
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Προγράμματος 5: Τρίτεκνες Πολύτεκνες Μητέρες
                        </a>
                        <br />
                        <br />
                        <a
                            className=" ds-link small-font-size "
                            href="https://opeka.gr/wp-content/uploads/2025/11/%CE%9F%CE%A1%CE%9F%CE%99-%CE%A5%CE%A0%CE%9F%CE%A4%CE%A1%CE%9F%CE%A6%CE%99%CE%A9%CE%9D_4.11.2025.pdf"


                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Προγράμματος 6: Υποτροφίες Επιτυχόντων Τέκνων Πανελλαδικών Εξετάσεων
                        </a>
                    </p>
                }
            /> */}

            {/* <br /> */}
            <SimpleAccordion
                title={
                    <span style={{ fontWeight: "bold", color: "#003476", fontSize: 18 }}>
                        Κανόνες Επιλεξιμότητας Τέκνων
                    </span>
                }
                content={
                    <div
                        style={{
                            fontFamily: "Arial, sans-serif",
                            fontSize: "1rem",
                            lineHeight: "1.6",
                            color: "#222",
                        }}
                    >
                        <p>
                            Τα τέκνα που λαμβάνονται υπόψη για τη χορήγηση της παροχής πρέπει να είναι{" "}
                            <strong>άγαμα</strong> και <strong>άνεργα</strong> και:
                        </p>

                        <ul style={{ listStyleType: "disc", paddingLeft: "22px", marginTop: "10px" }}>
                            <li style={{ marginBottom: "10px" }}>
                                να μην υπερβαίνουν το δέκατο όγδοο (18<sup>ο</sup>) έτος της ηλικίας τους,
                                ή το δέκατο ένατο (19<sup>ο</sup>) έτος εφόσον συνεχίζουν τη φοίτησή τους
                                στη μέση εκπαίδευση,<strong> ή</strong>
                            </li>
                            <li style={{ marginBottom: "10px" }}>
                                να μην υπερβαίνουν το εικοστό τέταρτο (24<sup>ο</sup>) έτος, εφόσον σπουδάζουν σε Ίδρυμα
                                Ανώτατης ή Ανώτερης Εκπαίδευσης στην Ελλάδα ή στο εξωτερικό ή φοιτούν στο{" "}
                                <strong>«Μεταλυκειακό έτος - Τάξη Μαθητείας»</strong> των Επαγγελματικών
                                Λυκείων (ΕΠΑ.Λ.) ή σε Ινστιτούτα Επαγγελματικής Κατάρτισης (Ι.Ε.Κ), <strong> ή</strong>
                            </li>
                            <li style={{ marginBottom: "10px" }}>
                                να είναι παιδιά με ποσοστό αναπηρίας πενήντα τοις εκατό (50%) και άνω
                                ανεξαρτήτως ηλικίας.
                            </li>
                        </ul>

                        <p style={{ marginTop: "10px" }}>
                            <strong>Προσδιορισμός ηλικίας τέκνων</strong>: Ως ημερομηνία συμπλήρωσης του{" "}
                            18<sup>ου</sup>, 19<sup>ου</sup> και 24<sup>ου</sup> έτους ηλικίας
                            θεωρείται η <strong>31η Δεκεμβρίου του έτους 2025</strong>, ανεξάρτητα
                            από το μήνα γέννησης.
                        </p>
                        <p>
                            Επιπλέον, τα τέκνα που λαμβάνονται υπόψη για τη χορήγηση της παροχής πρέπει να έχουν ενεργή ασφαλιστική ικανότητα που απορρέει από άμεσα δικαιούχο του ΛΑΕ/ΟΠΕΚΑ.
                        </p>
                    </div>
                }
            />
            <br />

            <SimpleAccordion
                title={
                    <span style={{ fontWeight: "bold", color: "#003476", fontSize: 18 }}>
                        Περίοδος Υποβολής Αιτήσεων
                    </span>
                }
                content={
                    <div
                        style={{
                            fontFamily: "Arial, sans-serif",
                            fontSize: "1rem",
                            lineHeight: "1.6",
                            color: "#222",
                        }}
                    >                        <p>
                            Οι αιτήσεις για τη χορήγηση της παροχής των Χρηματικών Βοηθημάτων – Βραβείων υποβάλλονται εντός <strong>αποκλειστικής χρονικής</strong> προθεσμίας, που ξεκινά τη <strong> Δευτέρα 15 Ιουνίου 2026 </strong> και ώρα <strong>15:00 </strong> και λήγει την <strong> Τετάρτη 22 Ιουλίου 2026 </strong> και ώρα  <strong>23:59</strong>.
                        </p>

                    </div >
                    // <div style={containerStyle}>

                    //     <table style={tableStyle}>
                    //         <tbody>
                    //             <tr>
                    //                 <td style={leftCellStyle}>
                    //                     <span style={underlineBold}>Πρόγραμμα 5:</span> Τρίτεκνες / Πολύτεκνες Μητέρες
                    //                 </td>
                    //                 <td style={rightCellStyle}>
                    //                     28/07/2025 09:00 - 22/09/2025 23:59
                    //                 </td>
                    //             </tr>
                    //             <tr>
                    //                 <td style={leftCellStyle}>
                    //                     <span style={underlineBold}>Πρόγραμμα 6:</span> Υποτροφίες Επιτυχόντων Τέκνων τους στις Πανελλαδικές Εξετάσεις (Νέο Πρόγραμμα)
                    //                 </td>
                    //                 <td style={rightCellStyle}>
                    //                     10/11/2025 16:00 - 01/12/2025 23:59
                    //                 </td>
                    //             </tr>
                    //         </tbody>
                    //     </table>
                    // </div>
                }
            />
            < br />
            <SimpleAccordion
                title={
                    <span style={{ fontWeight: "bold", color: "#003476", fontSize: 18 }}>
                        Επεξεργασία Προσωπικών Δεδομένων
                    </span>
                }
                content={
                    <p>
                        Με την υποβολή της αίτησης συμμετοχής παρέχεται η{" "}
                        <strong>συγκατάθεση προς τον ΟΠΕΚΑ</strong> για την επεξεργασία των προσωπικών δεδομένων τόσο του προσώπου που υποβάλει την αίτηση, όσο και των μελών της οικογένειάς του που συμπεριλαμβάνει σε αυτήν και για τη λήψη ενημερώσεων από τον Οργανισμό μέσω email ή/και sms, αποκλειστικά για τους σκοπούς του προγράμματος.
                    </p>
                }
            />
            <br />

        </>
    );
};

export default LegalFiles2026;
